
import axios from '../wmsAxios'

/*
 * 机构管理模块
 */

// 保存
export const save = (data) => {
    return axios({
        url: '/tAfaViewWaveOrderLine/save',
        method: 'post',
        data
    })
}

// 删除
export const batchDelete = (data) => {
    return axios({
        url: '/tAfaViewWaveOrderLine/delete',
        method: 'post',
        data
    })
}

// 查询分页数据
export const findPage = (data) => {
    return axios({
        url: '/tAfaViewWaveOrderLine/findPage',
        method: 'post',
      data
    })
}




// WEBPACK FOOTER //
// ./src/http/moudules/tAfaViewWaveOrderLine.js